var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('TopProgressBar'),_c('NavigationDrawer'),_c('Toolbar'),(!_vm.$isClient())?_c('DocumentDropzone'):_vm._e(),_c('v-main',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }